import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { AlertFilled } from "@ant-design/icons";
import { Progress } from "antd";
const SavingProgressModal = ({ percent, currentCount, totalCount, message = "Your responses are being saved.", warning = "This usually takes 2–10 minutes. Please stay until the process completes.", footerText = "saving...", }) => {
    return (_jsx(Backdrop, { children: _jsxs(Card, { children: [_jsx(Glow, {}), _jsx(IconBadge, { children: _jsx(StyledAlertIcon, {}) }), _jsx(Title, { children: "Don't close or refresh" }), _jsx(SubTitle, { children: message }), _jsxs(ProgressWrapper, { children: [_jsx(Progress, { type: "circle", percent: percent, width: 120, strokeColor: "#FF7A6D", trailColor: "#F2F2F5" }), _jsxs(ProgressCount, { children: [_jsx("span", { children: currentCount }), " / ", _jsx("span", { children: totalCount })] })] }), _jsx(WarningText, { children: warning }), _jsx(FooterBar, { children: footerText })] }) }));
};
const Backdrop = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
const Card = styled.div `
  width: 100%;
  max-width: 400px;
  padding: 32px 32px 0;
  background: linear-gradient(180deg, #fff7f5 0%, #ffffff 70%);
  border-radius: 8px;
  box-shadow: 0 25px 50px -12px rgba(255, 105, 97, 0.35);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  overflow: hidden;
`;
const Glow = styled.div `
  position: absolute;
  top: -60px;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 187, 167, 0.45) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  pointer-events: none;
`;
const IconBadge = styled.div `
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #fff5f3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 10px 30px rgba(255, 121, 103, 0.2);
  z-index: 1;
`;
const StyledAlertIcon = styled(AlertFilled) `
  font-size: 30px;
  color: #ff6b6b;
`;
const Title = styled.h3 `
  margin: 0;
  font-size: clamp(16px, 3.2vw, 28px);
  font-weight: 600;
  color: #ff6b6b;
  z-index: 1;
`;
const SubTitle = styled.p `
  margin: 0;
  font-size: 16px;
  color: #6c6c6c;
  z-index: 1;
`;
const ProgressWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  z-index: 1;
`;
const ProgressCount = styled.div `
  font-size: 18px;
  color: #5a5a5a;
  span {
    font-weight: 600;
  }
`;
const WarningText = styled.p `
  font-size: 16px;
  color: #7a7a7a;
  margin: 0 0 16px;
  font-style: italic;
  z-index: 1;
`;
const FooterBar = styled.div `
  width: calc(100% + 64px);
  margin-left: -32px;
  background: #ffe9e4;
  color: #ff6b6b;
  font-weight: 600;
  padding: 16px;
  text-transform: lowercase;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
export default SavingProgressModal;
